import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex items-center gap-2 px-6 py-3 text-primary-500 bg-primary-100 rounded-lg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "This is your proposal", -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 1,
  class: "w-5 h-5 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = {
  key: 0,
  class: "w-5 h-5",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("path", { d: "M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "w-5 h-5 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]

import { ref, computed } from "vue";
import { useProposalStore } from "@/stores/proposals";


export default /*#__PURE__*/_defineComponent({
  props: {
  proposalId: {
    type: Number,
    required: true,
  },
  status: {
    type: String as () => ProposalStatus,
    required: true,
  },
  hasSupported: {
    type: Boolean,
    default: false,
  },
  isAuthor: {
    type: Boolean,
    default: false,
  },
},
  emits: ["supported", "withdrawn"],
  setup(__props, { emit }) {

const props = __props





const proposalStore = useProposalStore();
const loading = ref(false);
const message = ref("");
const isError = ref(false);

const canSupport = computed(() => {
  return props.status === "gathering_support" && !props.hasSupported;
});

const canWithdraw = computed(() => {
  return props.status === "gathering_support" && props.hasSupported;
});

const showMessage = (text: string, error = false) => {
  message.value = text;
  isError.value = error;
  setTimeout(() => {
    message.value = "";
  }, 3000);
};

const handleSupport = async () => {
  if (!canSupport.value) return;

  loading.value = true;
  try {
    const response = await proposalStore.supportProposal(props.proposalId);
    if (response.threshold_reached) {
      showMessage(
        "Support added! This proposal has reached its threshold and is ready for vote."
      );
    } else {
      showMessage("Thank you for supporting this proposal!");
    }
    emit("supported", response);
  } catch (error: any) {
    showMessage(error?.response?.data?.error || "Failed to add support", true);
  } finally {
    loading.value = false;
  }
};

const handleWithdraw = async () => {
  if (!canWithdraw.value) return;

  loading.value = true;
  try {
    await proposalStore.withdrawSupport(props.proposalId);
    showMessage("Support withdrawn successfully.");
    emit("withdrawn");
  } catch (error: any) {
    showMessage(
      error?.response?.data?.error || "Failed to withdraw support",
      true
    );
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.isAuthor)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (!__props.hasSupported)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: handleSupport,
            disabled: loading.value || !_unref(canSupport),
            class: _normalizeClass(["inline-flex items-center gap-2 px-6 py-3 font-medium text-white rounded-lg transition-all duration-200", 
        _unref(canSupport)
          ? 'bg-accent-700 hover:bg-accent-800 active:scale-95'
          : 'bg-gray-300 cursor-not-allowed'
      ])
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
              : (_openBlock(), _createElementBlock("svg", _hoisted_9, _hoisted_12)),
            _createElementVNode("span", null, _toDisplayString(loading.value ? "Supporting..." : "Support This Proposal"), 1)
          ], 10, _hoisted_5))
        : (_openBlock(), _createElementBlock("button", {
            key: 2,
            onClick: handleWithdraw,
            disabled: loading.value || !_unref(canWithdraw),
            class: _normalizeClass(["inline-flex items-center gap-2 px-6 py-3 font-medium rounded-lg border-2 transition-all duration-200", 
        _unref(canWithdraw)
          ? 'border-accent-700 text-accent-700 hover:bg-accent-50 active:scale-95'
          : 'border-gray-300 text-gray-400 cursor-not-allowed'
      ])
          }, [
            (!loading.value)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_14, _hoisted_16))
              : (_openBlock(), _createElementBlock("svg", _hoisted_17, _hoisted_20)),
            _createElementVNode("span", null, _toDisplayString(loading.value ? "Withdrawing..." : "Withdraw Support"), 1)
          ], 10, _hoisted_13)),
    (message.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["mt-3 p-3 rounded-lg text-sm", 
        isError.value ? 'bg-red-100 text-red-700' : 'bg-accent-100 text-accent-700'
      ])
        }, _toDisplayString(message.value), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})